import { MediaType } from '../DolEditor/elements/media-constant';
import { ResultImageWithBlankPluginAdminItem } from './ResultImageWithBlankPluginAdminItem';

export interface ResultImageWithBlankPluginOptions {
  blanks: any;
  testMode: any;
}

export const ResultImageWithBlankPlugin = (props) => {
  return {
    renderElement: ResultImageWithBlankPluginAdminItem(props),
    voidTypes: [MediaType.IMAGE],
    renderElementDeps: [
      props?.blanks,
      props?.currentSelectedIndex,
      props?.showQuestionNo,
      props?.testMode,
    ],
  };
};
